var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 29.4 31.6",
    style: {
      enableBackground: "new 0 0 29.4 31.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_24662",
    transform: "translate(-3.293 -5.156)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20609",
    style: {
      fill: "none",
      stroke: "#005BA9",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M22,36.2c0-2.7,0-7.2,0-9.9c0.1-0.5-0.3-1.1-0.8-1.1c-0.1,0-0.2,0-0.3,0c-1.9,0-3.7,0-5.6,0c-0.9,0-1.3,0.3-1.3,1.2 c0,2.7,0,7.1,0,9.7 M18,20.4c1.7,0,3.1-1.3,3.1-3c0,0,0-0.1,0-0.1c0-1.7-1.4-3.2-3.1-3.2c0,0-0.1,0-0.1,0c-1.7,0-3.1,1.4-3.2,3.2 C14.9,19,16.3,20.4,18,20.4L18,20.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20610",
    style: {
      fill: "none",
      stroke: "#005BA9",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M29.1,10.9v22.6c0,1.5-1.2,2.7-2.7,2.7H9.6c-1.5,0-2.7-1.2-2.7-2.7V16.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20611",
    style: {
      fill: "none",
      stroke: "#005BA9",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M32,19.7l-14-14l-14,14"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.05e8a8758aa93fe56225f272bbbbe891.svg";
export { ForwardRef as ReactComponent };